import { render, staticRenderFns } from "./CostingForm.vue?vue&type=template&id=446b3c0c&scoped=true&"
import script from "./CostingForm.vue?vue&type=script&lang=js&"
export * from "./CostingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446b3c0c",
  null
  
)

export default component.exports